import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  PromoSection,
  PromoBox,
  PromoTextContainer,
  PromoTitle,
  PromoDescription,
  PromoAppLinks,
  PromoAppLink,
  PromoAppImage,
  PromoSideImages,
  PromoSideLeftImage,
  PromoSideRightImage,
  PromoLogo,
  PromoTitleContainer,
} from './styles'

import logo from 'assets/images/logos/lif-brand.svg'
import appstore from 'assets/images/wallet/app-store.svg'
import googleplay from 'assets/images/wallet/google-play.svg'
import phones from 'assets/images/wallet/promo-wallet.png'
import SideImageOne from 'assets/images/landing/landing-promo-1.png'
import SideImageTwo from 'assets/images/landing/landing-promo-2.png'

const isLif3WalletUserAgent = () => {
  return /Lif3Wallet/i.test(navigator.userAgent)
}

const isLifeWalletApp = isLif3WalletUserAgent()

export default function WalletPromo() {
  const { t } = useTranslation('wallet')

  return (
    <PromoSection>
      <PromoBox>
        <PromoTextContainer>
          <PromoTitleContainer>
            <PromoLogo src={logo} alt="Lif3 Logo" />
            <PromoTitle>{t('Wallet')}</PromoTitle>
          </PromoTitleContainer>
          <PromoDescription>{t('with Seamless Integration to the Lif3 Ecosystem.')}</PromoDescription>
        </PromoTextContainer>
        <PromoAppLinks>
          <PromoAppLink
            href="https://apps.apple.com/app/apple-store/id6444389674?pt=124991242&ct=Website&mt=8"
            target="_blank"
            rel="noreferrer"
          >
            <PromoAppImage src={appstore} alt="App Store" />
          </PromoAppLink>
          <PromoAppLink
            href="https://play.google.com/store/apps/details?id=com.lif3.wallet"
            target="_blank"
            rel="noreferrer"
          >
            <PromoAppImage src={googleplay} alt="Google Play" />
          </PromoAppLink>
        </PromoAppLinks>
      </PromoBox>
      <PromoSideImages isLifeWallet={isLifeWalletApp}>
        <PromoSideLeftImage src={SideImageOne} alt="Lif3 Wallet" />
        <PromoSideRightImage src={SideImageTwo} alt="Lif3 Wallet" />
      </PromoSideImages>
    </PromoSection>
  )
}
